import { atom } from "jotai";
export const userAtom = atom(null);